import {
  fetchTicketLoading,
  fetchTicketSuccess,
  fetchTicketFail,
  fetchSearchTickets,
  selectedTicketFail,
  selectedTicketSuccess,
  selectTicketProcessing,
  replyLoading,
  replySuccess,
  replyFail,
} from "./TicketSlice";
import { getSingleTicket, sendreply } from "./utilities/userauth";
import axios from "axios";
export const fetchTickets = () => async (dispatch) => {
  dispatch(fetchTicketLoading());

  try {
    const result = await axios.get(
      "https://crm-beckend-amrinder-org.onrender.com/v1/ticket",
      {
        headers: {
          authorization: sessionStorage.getItem("accessJwt"),
        },
      }
    );
    console.log(result);
    dispatch(fetchTicketSuccess(result.data.data));
  } catch (error) {
    console.log("errrr", error);
    dispatch(fetchTicketFail(error.message));
  }
};

export const fetchedSearchedTickets = (str) => (dispatch) => {
  dispatch(fetchSearchTickets(str));
};

export const getingsingleTicket = (id) => async (dispatch) => {
  try {
    dispatch(selectTicketProcessing());

    const ticket = await getSingleTicket(id);
    // console.log("mera tickrt ", ticket.data.Ticket[0]);
    dispatch(selectedTicketSuccess(ticket.data.Ticket[0]));
  } catch (error) {
    dispatch(selectedTicketFail(error));
  }
};

export const sendreplyy = (id, msgobj) => async (dispatch) => {
  try {
    dispatch(replyLoading());
    const replysend = await sendreply(id, msgobj);
    console.log("reply sended bny amriknder ", replysend);
    dispatch(replySuccess());
  } catch (error) {
    dispatch(replyFail(error));
  }
};
